import './administrar-domicilios.css'
import Domicilios from './Domicilios'
import Hero from './Hero'

const AdministrarDomicilios = () => {
  return (
    <div>
      <div className="col">
        <Hero />
        <hr className="hr-blue w-70"></hr>
        <Domicilios />
      </div>
    </div>
  )
}

export default AdministrarDomicilios
